/**
 * Created by rathompson on 4/13/22
 * File: AppNames
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { APP_ID_TO_NAME } from './GlobalConstants'
import type { AppManifest } from '@sparky/framework'


const appNames = ((apps: AppManifest) => {
  const appBlacklist: any = Object.values(apps).reduce((array: any, app: any) => {
    if (app.no_app_tile_ui || app.hasOwnProperty('extension_to')) {
      array.push(app.app_id)
    }
    return array
  }, [])
  return {
    apps,
    getAppName: (app_id: string, defValue: string) => {
      return apps.get(app_id)?.display_name ?? APP_ID_TO_NAME[defValue] ?? defValue ?? 'None'
    },
    dontRenderApp: (app_id: string) => appBlacklist.includes(app_id)
  }
})

export default appNames
